import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as projectActions from "./../../../../actions/project.actions";

import ProjectIndex from "../components/ProjectIndex";

class ProjectIndexContainer extends Component {
  constructor(props) {
    super(props);

    this.editProject = this.editProject.bind(this);
    this.hideProject = this.hideProject.bind(this);
    this.viewSOW = this.viewSOW.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProjects();
  }

  editProject(id) {
    this.props.history.push(`/company/project/id/${id}/review`);
  }

  hideProject(id) {
    this.props.projectActions.hideProject(id);
  }

  viewSOW(project) {
    this.props.history.push(
      `/company/pitch/${project.selected.pitch.id}/member/${
        project.selected.member_id
      }/project/${project.id}/sow`
    );
  }

  render() {
    const projects = _.filter(this.props.projects, {
      hide: false
    });

    return (
      projects && (
        <ProjectIndex
          projects={projects}
          editProject={this.editProject}
          hideProject={this.hideProject}
          viewSOW={this.viewSOW}
        />
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    projects: state.project.projects
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectIndexContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/projectIndex/containers/ProjectIndexContainer.js